export default __webpack_public_path__ + "static/media/facebook.36adde35.svg";